import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { AdminDocumentaryResourceVM } from "@shared-kernel/domain/types/documentary-resource";

export const documentaryResourceCatalogRetrieve = createAsyncThunk<AdminDocumentaryResourceVM[], void, { extra: Partial<Dependencies> }>(
  "documentaryResourceCatalog/retrieve",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.getDocumentaryResourcesCatalog();
  },
);
